import React from 'react';
import QuizContainer from './components/QuizContainer';
import LandingPage from './components/Landing/LandingPage';
import { Route, Switch } from 'react-router-dom';
// import ScoreCard from './components/ScoreCard/ScoreCard.jsx';
import LeaderBoards from './components/LeaderBoards/LeaderBoards.jsx';
import About from './components/About/About.jsx';
import './App.css';

function App() {
  return (
    <div className='App'>
      <Switch>
        <Route exact path='/' component={LandingPage} />
        <Route exact path='/map-quiz' component={QuizContainer} />
        {/* <Route exact path='/score' component={ScoreCard} /> */}
        <Route exact path='/leaderboards' component={LeaderBoards} />
        <Route exact path='/about' component={About} />
      </Switch>
    </div>
  );
}

export default App;
